// Away is always the same color everywhere, regardless of theme, and in all Outlook clients
// keep in sync with color definition in freeBusyStyles.scss if ever changes
export const AwayColor = '#b4009e';
